import React from 'react';
import styled from 'styled-components';
import mobileLogo from '../images/logo-light-mobil.png';

const Logo = styled.img`
  min-width: 270px;  /* antes 180px */
  min-height: 120px; /* antes 80px */
  max-width: 420px;  /* antes 280px */
  max-height: 225px; /* antes 150px */
  object-fit: contain;
  margin-left: -1rem;
  margin-bottom: -4rem;
  object-position: center;
`;

export default () => {
  return (
    <Logo src={mobileLogo} alt="Logo Mobile" />
  );
};